import { api } from "../../../axios";

export const fetchSurveyDocuments = async (
  token: string,
  clientId: number,
  accountId: number
) => {
  const response = await api.get(
    `signature/submissions/${clientId}/survey_documents?account_id=${accountId}`,
    {
      headers: { token: token }
    }
  );

  return response.data;
};

export const fetchDownloadUrl = async (
  token: string,
  surveyDocumentId: number
) => {
  const response = await api.get(
    `/signature/submissions/${surveyDocumentId}/download_urls`,
    {
      headers: { token: token }
    }
  );

  return response.data;
};
